import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { productsQueryMatchesURL } from 'src/redux/productsQuery/helpers/productsQueryMatchesURL';
import { syncFromURL } from 'src/redux/productsQuery/thunks/syncFromURL';
import type { AppThunkDispatch } from 'src/redux/store';
import { scrollToTopOfProductsList } from 'src/utils/scrollToTopOfProductsList';

export const useSyncProductsQueryFromUrl = () => {
  const dispatch = useDispatch<AppThunkDispatch>();
  const router = useRouter();
  const lastHandledAsPath = useRef<string | null>(null);
  const state = useSelector((s: ReduxApplicationState) => s);

  useEffect(() => {
    if (!router.isReady || lastHandledAsPath.current === router.asPath) {
      return;
    }

    if (productsQueryMatchesURL(router.asPath, state)) {
      lastHandledAsPath.current = router.asPath;
      return;
    }
    lastHandledAsPath.current = router.asPath;

    dispatch(syncFromURL(router.asPath));

    scrollToTopOfProductsList();
  }, [dispatch, router.asPath, router.isReady, state]);
};
